import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { IQueryParams } from '../../../models/common/IQueryParams';
import { sourceListRegistrySchema } from '../../../utilities/sources/RegistriesSchemaDefintion';
import { fetchSourceRegistryList } from '../../actions/actionType/sources/SourceRegistryListActionTypes';
import { fetchAllSourceRegistryFailure, getAllSourceRegistryStarted, getAllSourceRegistrySuccess } from '../../actions/sagaActions/schedule-maintenance/GetAllSourceRegistriesSagaActions';
import { FetchAllSourceRegistriesFailurePayload, FetchAllSourceRegistriesRequest, IActiveSource } from '../../actions/types/sources/GetAllSourceRegistries';
/**
 * Call Gets source registries by API
 * @returns api response
 */
export async function callGetAllSourceRegistriesApi(pageNo: number, item: number, queryParams?: IQueryParams, sort?: string) {
  const urlString = `${process.env.REACT_APP_API_BASE_URL}/sources/search?page=${pageNo}&size=${item}&sort=${sort || 'DESC'}`;
  const requestBody = queryParams ? {
    sources: queryParams.searchText ? [{ sourceName: queryParams.searchText }] : [],
    status: queryParams.status ? [queryParams.status] : [],
    fromDate: queryParams.fromDate ? (queryParams.fromDate) : '',
    toDate: queryParams.toDate ? (queryParams.toDate) : '',
  } : {};

  const resp = await apiWrapper.post<IActiveSource, { errorMessage: string }>(
    urlString,
    requestBody,
    headersInstance()
  );

  const apiResponse = sourceListRegistrySchema.validate(resp.responseBody, {
    abortEarly: true
  });

  if (resp.isError || !apiResponse.value) {
    return {
      errorMessage: resp.errorBody?.errorMessage,
      isError: resp.isError,
      statusCode: resp.statusCode
    };
  }
  const sourceList = resp.responseBody;
  return {
    sourceList,
    isError: resp.isError,
    statusCode: resp.statusCode
  };
}

export function* getAllSourceRegistries({ pageNo, item, queryParams, sort }: FetchAllSourceRegistriesRequest) {
  yield put(getAllSourceRegistryStarted());
  try {
    const { sourceList, errorMessage } = yield call(callGetAllSourceRegistriesApi, pageNo, item, queryParams, sort);

    if (sourceList) {
      if (errorMessage) {
        throw new Error('No Response');
      } else {
        yield put(getAllSourceRegistrySuccess(sourceList));
      }
    }
  } catch (error) {
    const obj: FetchAllSourceRegistriesFailurePayload = {
      error: String(error)
    };
    yield put(fetchAllSourceRegistryFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* fetchAllSourceRegistriesSaga() {
  yield takeLatest(fetchSourceRegistryList.FETCH_SOURCE_REGISTRY_LIST_REQUEST, getAllSourceRegistries);
}

export const getAllSourceRegistriesSaga = [fork(fetchAllSourceRegistriesSaga)];
